import { Component, OnInit } from '@angular/core';
import {PickerItem} from '@lib-modules/picker/components/picker-item/picker-item.component';
import {LeagueService} from '@core/services/league.service';
import {VideoContentType} from '@lib-modules/cards/services/video-card/video-card.service';

@Component({
  selector: 'app-league-livestreams',
  templateUrl: './league-livestreams.component.html',
  styleUrls: ['./league-livestreams.component.scss']
})
export class LeagueLivestreamsComponent implements OnInit {

  public videoType = VideoContentType.ActiveStreams;
  public pickerItem: PickerItem;

  constructor(public leagueService: LeagueService) { }
  ngOnInit(): void {
    this.pickerItem = this.leagueService.currentLeague.getAsPickerItem();
  }
}
